<template>
  <div class="faculty p_t">
    <TopHead title="师资力量"></TopHead>
    <div class="f_c">

      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <van-list
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="items d_f cur_p" v-for="(item,index) in list" :key="index" @click="$router.push('/FacultyDetail?teacherId='+item.teacherId)">
            <img :src="item.picUrl" alt="">
            <div class="flex_1">
              <div class="name">{{item.teacherName}}</div>
              <div class="tags">
                <span v-for="(itm,idx) in item.teacherTags" :key="idx">
                  {{itm}}<span v-if="idx < item.teacherTags.length-1">、</span>
                </span></div>
              <div class="tags_detail">{{item.synopsis.replace(/<\/?.+?\/?>/g,'')}}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Faculty",
    data() {
      return {
        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        params:{
          pageIndex:1,
          pageSize:10,
        },
      }
    },
    created(){
      this.listTeacher();
    },
    methods: {
      listTeacher(){
        this.loading = true;
        this.$api.listTeacher(this.params).then(res => {

          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listTeacher();
      },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listTeacher();
      },
    }
  }
</script>

<style scoped lang="scss">
  .f_c{
    .items{
      .flex_1{
        padding: 10px 9px 10px 0;
      }
      .tags_detail{
        padding-top: 14px;
        border-top: 1px solid #DBDBDB;
        font-size: 10px;
        font-weight: 500;
        color: #333333;
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .tags{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 12px;
        font-weight: 500;
        color: #ff8039;
        height: 32px;
      }
      .name{
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 10px;
      }
      img{
        width: 100px;
        /*height: 130px;*/
        margin-right: 12px;
      }
      background: #F6F6F6;
      border: 1PX solid #DADADA;
      border-radius: 5px;
      overflow: hidden;
      margin-bottom: 17px;
      box-sizing: border-box;
    }
    padding: 18px 13px;
  }

</style>
